// Définition centralisée des sections (entrées du menu de gauche) contrôlables par utilisateur.
// Utilisé par AppLayout (visibilité effective) et AdminPage (matrice d'accès par utilisateur).

export const SECTION_DEFS = [
  { to: '/dashboard', label: 'Tableau de bord' },
  { to: '/simulation/new', label: 'Nouvelle Simulation' },
  { to: '/rapports', label: 'Rapports' },
  { to: '/croquis-agenceur', label: 'Croquis Agenceur' },
  { to: '/golden-info', label: "Info d'Or" },
  { to: '/announcements', label: 'Annonces ALL' },
  { to: '/chantiers', label: 'Pilotage Chantier' },
  { to: '/pv-livraison', label: 'PV de Livraison' },
  { to: '/prerequis-techniques', label: 'Prérequis Techniques' },
  { to: '/contract-requests', label: 'Demande de Contrat' },
  { to: '/dossiers-agenceur', label: 'Commande Corner' },
  { to: '/business-commercial', label: 'Business Commercial' },
  { to: '/planning-chantiers', label: 'Planning chantiers' },
  { to: '/performance', label: 'Performance' },
  { to: '/ca-corner', label: 'CA Corner' },
  { to: '/carte-corners', label: 'Carte des Corners' },
  { to: '/history', label: 'Historique' },
  { to: '/guide', label: 'Guide' },
  { to: '/guide-pv', label: 'Présentation PV' },
  { to: '/assistant', label: 'Assistant CAPEX' },
];

export const MANAGEABLE_ROUTES = new Set(SECTION_DEFS.map(s => s.to));

const ALWAYS = new Set([
  '/dashboard', '/simulation/new', '/rapports', '/croquis-agenceur', '/golden-info', '/announcements', '/chantiers',
  '/pv-livraison', '/prerequis-techniques', '/contract-requests', '/history', '/guide',
  '/guide-pv', '/assistant',
]);
const BUSINESS = new Set(['commercial', 'commerciale', 'admin', 'super_admin', 'assistante_commerciale']);
const PERF = new Set(['super_admin', 'admin', 'commercial', 'commerciale']);

// Accès par défaut d'un rôle à une section (reproduit la logique historique de la sidebar).
export function roleDefaultAccess(role, to, flags = {}) {
  const { caCornerAccess = false, isAdmin = false } = flags;
  if (role === 'super_admin') return true;
  if (ALWAYS.has(to)) return true;
  switch (to) {
    case '/dossiers-agenceur': return !!isAdmin;
    case '/business-commercial': return ['admin', 'commercial', 'commerciale'].includes(role);
    case '/planning-chantiers': return BUSINESS.has(role);
    case '/performance': return PERF.has(role);
    case '/ca-corner':
    case '/carte-corners': return !!caCornerAccess;
    default: return false;
  }
}

// Visibilité effective = surcharge par utilisateur si définie, sinon défaut du rôle.
export function effectiveAccess(role, to, sectionAccess, flags = {}) {
  if (role === 'super_admin') return true;
  if (sectionAccess && Object.prototype.hasOwnProperty.call(sectionAccess, to)) {
    return !!sectionAccess[to];
  }
  return roleDefaultAccess(role, to, flags);
}
